import { render } from "./romaneio-coletor-editar.vue?vue&type=template&id=0a015c78&scoped=true"
import script from "./romaneio-coletor-editar.vue?vue&type=script&lang=js"
export * from "./romaneio-coletor-editar.vue?vue&type=script&lang=js"

import "./romaneio-coletor-editar.vue?vue&type=style&index=0&id=0a015c78&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a015c78"]])

export default __exports__